import { AudioResources, GameEvents, MenuEvents, PlayerEvents } from '@game-libs/models';
import { Gif, ImageSource, Sound } from 'excalibur';
import { GameLoader } from './loader';

export const loader = new GameLoader();

export const Music = {
  game_music: new Sound(
    import.meta.env.VITE_IS_PROD === 'true' ? './music/game_music.ogg' : './music/game_music_dev.ogg',
  ),
  dungeon_music: new Sound('./music/dungeon_full.ogg'),
} as const;

export const Spritesheets: Record<string, ImageSource> = {
  dragon: new ImageSource('./spritesheets/dragon-small-sheet.png'),
  dragon_big_idle: new ImageSource('./spritesheets/dragon-big-sheet_idle_new.png'),
  dragon_big_fire: new ImageSource('./spritesheets/dragon-big-sheet_fire.png'),
  dragon_big_roar: new ImageSource('./spritesheets/dragon-big-sheet_roar.png'),
  bird: new ImageSource('./spritesheets/parrot-sheet.png'),
  warrior: new ImageSource('./spritesheets/units/warrior-sheet.png'),
  elf: new ImageSource('./spritesheets/units/elf-sheet.png'),
  wizard: new ImageSource('./spritesheets/units/wizard-sheet.png'),
  thief: new ImageSource('./spritesheets/units/thief-sheet.png'),
  cleric: new ImageSource('./spritesheets/units/cleric-sheet.png'),
  bard: new ImageSource('./spritesheets/units/bard-sheet.png'),
  catapult: new ImageSource('./spritesheets/units/catapult-sheet.png'),
  hit_1: new ImageSource('./spritesheets/hit_1.png'),
  hit_2: new ImageSource('./spritesheets/hit_2.png'),
  critical_hit: new ImageSource('./spritesheets/critical_hit.png'),
  explosion: new ImageSource('./spritesheets/death_explosion.png'),
  swing_1: new ImageSource('./spritesheets/swing_1.png'),
  smoke: new ImageSource('./spritesheets/smoke.png'),
  arrival_smoke: new ImageSource('./spritesheets/arrival_smoke.png'),
  lightning: new ImageSource('./spritesheets/lightning.png'),
  poison: new ImageSource('./spritesheets/poison.png'),
  dummy: new ImageSource('./spritesheets/dummy_spritesheet.png'),
  king: new ImageSource('./spritesheets/king-sheet.png'),
} as const;

export const SFX: Partial<AudioResources['SFX']> = {
  [MenuEvents.FOCUS_BUTTON]: new Sound('./sfx/gui/menu-1.ogg'),
  [MenuEvents.SELECT]: new Sound('./sfx/gui/select-1.ogg'),
  [MenuEvents.CHANGE_VALUE]: new Sound('./sfx/gui/select-1.ogg'),
  [GameEvents.QUIT]: new Sound('./sfx/gui/quit-1.ogg'),
  [GameEvents.START]: new Sound('./sfx/gui/select-2.ogg'),
  [GameEvents.SAVE]: new Sound('./sfx/gui/select-1.ogg'),
  [PlayerEvents.INTERACT]: new Sound('./sfx/gui/select-2.ogg'),
  [PlayerEvents.PICK_ITEM]: new Sound('./sfx/gui/select-1.ogg'),
  [GameEvents.START_DIALOG]: new Sound('./sfx/gui/start-dialog.ogg'),
  thats: new Sound('./sfx/game/thats.ogg'),
  heal: new Sound('./sfx/game/heal.ogg'),
  poisonHit: new Sound('./sfx/game/poison.ogg'),
  lightningHit: new Sound('./sfx/game/lightning.ogg'),
  mana_fill: new Sound('./sfx/game/mana_fill.ogg'),
  mana_out: new Sound('./sfx/game/mana_out.ogg'),
  sword_1: new Sound('./sfx/sword/sword_1.ogg'),
  sword_2: new Sound('./sfx/sword/sword_2.ogg'),
  sword_3: new Sound('./sfx/sword/sword_3.ogg'),
  sword_4: new Sound('./sfx/sword/sword_4.ogg'),
  sword_5: new Sound('./sfx/sword/sword_5.ogg'),
  sword_6: new Sound('./sfx/sword/sword_6.ogg'),
  crash: new Sound('./sfx/game/crash.ogg'),
  coin_1: new Sound('./sfx/coin/coin_1.ogg'),
  coin_2: new Sound('./sfx/coin/coin_2.ogg'),
  coin_3: new Sound('./sfx/coin/coin_3.ogg'),
  hover_1: new Sound('./sfx/gui/hover-1.ogg'),
  hover_2: new Sound('./sfx/gui/hover-2.ogg'),
  hover_3: new Sound('./sfx/gui/hover-3.ogg'),
  roar_1: new Sound('./sfx/roar/roar_1.ogg'),
  roar_2: new Sound('./sfx/roar/roar_2.ogg'),
  roar_3: new Sound('./sfx/roar/roar_3.ogg'),
  far_roar: new Sound('./sfx/roar/far_roar.ogg'),
  big_roar: new Sound('./sfx/roar/big_roar.ogg'),
  stomps: new Sound('./sfx/roar/stomps.ogg'),
  coin_many: new Sound('./sfx/coin/coin_many.ogg'),
  unlock: new Sound('./sfx/game/unlock.ogg'),
  unstun: new Sound('./sfx/game/unstun.ogg'),
  bird_coin: new Sound('./sfx/bird_coin.ogg'),
  chains: new Sound('./sfx/settings/chains.ogg'),
  haha_1: new Sound('./sfx/critical/haha_1.ogg'),
  haha_2: new Sound('./sfx/critical/haha_2.ogg'),
  haha_3: new Sound('./sfx/critical/haha_3.ogg'),
  huh_1: new Sound('./sfx/critical/huh_1.ogg'),
  huh_2: new Sound('./sfx/critical/huh_2.ogg'),
  huh_3: new Sound('./sfx/critical/huh_3.ogg'),
  huh_4: new Sound('./sfx/critical/huh_4.ogg'),
  yeah_1: new Sound('./sfx/critical/yeah_1.ogg'),
  yeah_2: new Sound('./sfx/critical/yeah_2.ogg'),
  yeah_3: new Sound('./sfx/critical/yeah_3.ogg'),
  yeah_4: new Sound('./sfx/critical/yeah_4.ogg'),
  take_that_1: new Sound('./sfx/critical/take_that_1.ogg'),
  cat_1: new Sound('./sfx/cats/cat_1.ogg'),
  cat_2: new Sound('./sfx/cats/cat_2.ogg'),
  cat_3: new Sound('./sfx/cats/cat_3.ogg'),
  cat_4: new Sound('./sfx/cats/cat_4.ogg'),
  pickup: new Sound('./sfx/dungeon/pickup.ogg'),
  nothing: new Sound('./sfx/dungeon/nothing.ogg'),
  start_battle: new Sound('./sfx/dungeon/start_battle.ogg'),
  door_open_1: new Sound('./sfx/dungeon/doorOpen_1.ogg'),
  door_open_2: new Sound('./sfx/dungeon/doorOpen_2.ogg'),
  chest_open: new Sound('./sfx/dungeon/chestOpen.ogg'),
  door_locked: new Sound('./sfx/dungeon/doorLocked.ogg'),
  footsteps_1: new Sound('./sfx/dungeon/footsteps/footstep01.ogg'),
  footsteps_2: new Sound('./sfx/dungeon/footsteps/footstep02.ogg'),
  footsteps_3: new Sound('./sfx/dungeon/footsteps/footstep03.ogg'),
  footsteps_4: new Sound('./sfx/dungeon/footsteps/footstep04.ogg'),
  footsteps_5: new Sound('./sfx/dungeon/footsteps/footstep05.ogg'),
  footsteps_6: new Sound('./sfx/dungeon/footsteps/footstep06.ogg'),
  footsteps_7: new Sound('./sfx/dungeon/footsteps/footstep07.ogg'),
} as const;

export const TypingSFX = {
  king: new Sound('./sfx/typing/king.ogg'),
  wizard: new Sound('./sfx/typing/king.ogg'),
  pope: new Sound('./sfx/typing/pope.ogg'),
  developer: new Sound('./sfx/typing/pope.ogg'),
  rogue: new Sound('./sfx/typing/rogue.ogg'),
  engineer: new Sound('./sfx/typing/engineer.ogg'),


  shadow: new Sound('./sfx/typing/shadow.ogg'),
  princess: new Sound('./sfx/typing/princess.ogg'),
} as const;

export const Images: Record<string, ImageSource> = {
  GameBKG: new ImageSource('./map/village.png'),
  DragonShadow: new ImageSource('./images/dragon_shadow.png'),
  UnderShadow: new ImageSource('./images/shadow.png'),
  unit_shadow: new ImageSource('./spritesheets/units/unit_shadow.png'),
} as const;

export const Gifs: Record<string, Gif> = {} as const;

// Configure music loops
for (const music of Object.values({
  ...Music,
})) {
  loader.addResource(music);
  music.loop = true;
}

for (const res of Object.values({
  ...SFX,
  ...TypingSFX,
  ...Images,
  ...Gifs,
  ...Spritesheets,
})) {
  loader.addResource(res);
}
